import { useRef } from 'react';
import XTable from 'components/XTable';
import { getUserListApi } from 'api/user';
const UserMGT = () => {
    const xTableRef = useRef();

    const columns = [
        {
            title: '用户id',
            dataIndex: 'id',
        },
        {
            title: '身份证号',
            dataIndex: 'idCard',
        },
    ];
    return (
        <div>
            <XTable columns={columns} api={getUserListApi} rowKey="id" ref={xTableRef} />
        </div>
    );
};
export default UserMGT;
